var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pool-info"},[_c('table',[_c('tbody',_vm._l((_vm.items),function(item,key){return _c('tr',{key:key},[_vm._m(0,true),_c('td',[_vm._v(" "+_vm._s(item)+" ")])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',[_c('img',{attrs:{"src":"","alt":"img"}})])
}]

export { render, staticRenderFns }